class RandomPicker<T> {
  private _copyArray: T[];

  private readonly _originalArray: T[];

  constructor(array: T[]) {
    this._originalArray = [...array];
    this._copyArray = [...array];
  }

  private randomIndex(max: number): number {
    return Math.floor(Math.random() * max);
  }

  pick(): T {
    if (this._copyArray.length === 0) {
      this._copyArray = [...this._originalArray];
    }

    const index = this.randomIndex(this._copyArray.length);
    const item = this._copyArray[index];
    this._copyArray.splice(index, 1);
    return item;
  }
}

export const multiPlayersColor = new RandomPicker([
  'var(--hive-multi-players-purple)',
  'var(--hive-multi-players-magenta)',
  'var(--hive-multi-players-red)',
  'var(--hive-multi-players-orange)',
  'var(--hive-multi-players-green)',
  'var(--hive-multi-players-blue)',
  'var(--hive-multi-players-brown)',
  'var(--hive-multi-players-grey)',
]);
